import { KeycloakService } from "keycloak-angular";
import { environment } from "src/environments/environment";

export function initializeKeycloak(keycloak: KeycloakService): () => Promise<boolean> {
  return () =>
    keycloak.init({
      config: {
        url: environment.keycloak.url,          
        realm: environment.keycloak.realm,       
        clientId: environment.keycloak.clientId   
      },
      initOptions: {
        //onLoad: 'login-required',
        //checkLoginIframe: false,
        redirectUri: environment.keycloak.redirectUri,  //'http://129.159.32.54/home',
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + (environment.templateSuffix === '' ? '/v1' : '/v2') + '/assets/silent-check-sso.html'
      },
      loadUserProfileAtStartUp: false,
      bearerExcludedUrls: environment.keycloak.bearerExcludedUrls
    });
}
